const tableColumns = [
    {
        title: "Sr No"
    },
    {
        title: "Source"
    },
    {
        title: "Destination"
    },
    {
        title: "Cost"
    },
    {
        title: "Duration"
    },
    {
        title: "Get Details"
    }
];

export default tableColumns;